var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.emailSignupBlockCoresiteV1 = {
    templateContainer: $('.js-email-signup-block-coresite-v1'),
    initEmailSignupBlock: function (context) {
      var self = this;
      var $emailContainer = self.templateContainer.find('.js-personal-info-form-container', context);

      if (!$emailContainer) {
        return null;
      }

      var $emailFormNode = $emailContainer.find('form');

      $emailFormNode.once('email_signup').on('submit', function (submitEvt) {
        submitEvt.preventDefault();

        $emailContainer.find('.form-error div').addClass('hidden');
        $emailContainer.find('.form-item').removeClass('label-error');

        var fields = [
          '_SUBMIT',
          'ACTION',
          'FIRST_NAME',
          'LAST_NAME',
          'EMAIL_ADDRESS',
          'EMAIL_ADDRESS2',
          'ADDRESS1',
          'ADDRESS2',
          'COUNTRY',
          'CITY',
          'POSTAL_CODE',
          'PHONE1',
          'EMAIL_PROMOTIONS',
          'ACCEPTED_PRIVACY_POLICY',
          'LANGUAGE_PREFERENCE',
          'LAST_SOURCE'
        ];
        var paramObj = {};

        // loop through all the fields and get the values
        $.each(fields, function (index, value) {
          var $formField = $emailContainer.find('input[name=' + value + ']');

          // for the unchecked checkboxes we want to send empty strings to backend for processing
          if ($formField.is(':checkbox') && !$formField.prop('checked')) {
            paramObj[value] = '';
          } else {
            paramObj[value] = $formField.val();
          }
        });
        if ($.cookie('csrftoken')) {
          paramObj['_TOKEN'] = $.cookie('csrftoken');
        }

        // Send the data via a json rpc call
        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [paramObj],
          onSuccess: function () {
            window.location.href = $emailContainer.find('input[name=THANK_YOU_PAGE]').val();
          },
          onFailure: function (jsonRpcResponse) {
            var messages = jsonRpcResponse.getMessages();
            var key, field, fieldClass;

            $.each(messages, function (i, message) {
              key = message.key.replaceAll('.', '-');
              key = '.js-' + key;
              field = message.tags[2];
              fieldClass = field.replace('field', '');

              $emailContainer.find(key).removeClass('hidden');
              $emailContainer.find('.form-item' + fieldClass).addClass('label-error');
            });
          }
        });
      });
    },
    attach: function (context) {
      var self = this;

      self.initEmailSignupBlock(context);
    }
  };
})(jQuery);
